import styled from "@emotion/styled";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { StatusLabelPill } from "./StatusLabelPill";

const ConceptPillStyled = styled(StatusLabelPill)(() => {
  const theme = useTheme();
  return {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
  };
});

export const ConceptPill = () => {
  const { t } = useTranslation();
  return <ConceptPillStyled>{t("Position.concept")}</ConceptPillStyled>;
};
